import React, { memo } from 'react';

const BigCallcenter = memo(({ size = 56 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.4134 45.6867C37.2777 45.6867 44.4636 38.2815 44.4636 29.1467C44.4636 20.0118 37.2777 12.6066 28.4134 12.6066C19.5492 12.6066 12.3633 20.0118 12.3633 29.1467C12.3633 38.2815 19.5492 45.6867 28.4134 45.6867Z"
        stroke="#1A85B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.03516 22.1384C10.8792 13.3459 18.9166 7 28.4132 7C37.9097 7 45.9472 13.3459 48.7665 22.1384"
        stroke="#1A85B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.8594 49.0002C43.2754 46.2733 47.4054 41.2526 49.0623 35.1616"
        stroke="#1A85B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4629 14.2122C21.4629 14.2122 27.8434 24.967 43.943 24.967"
        stroke="#1A85B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.0177 20.5074C28.0177 20.5074 25.4209 24.5596 12.9814 24.5596"
        stroke="#1A85B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.9043 22.0619H48.0235C48.2708 22.0619 48.5181 22.0619 48.7655 22.1384C50.4719 22.4952 51.7331 24.0498 51.7331 25.8847V31.517C51.7331 33.25 50.5955 34.7282 49.0622 35.1614C48.7407 35.2888 48.3945 35.3398 48.0235 35.3398H43.3"
        stroke="#1A85B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5253 35.3398H8.77697C8.40602 35.3398 8.05979 35.2888 7.73829 35.1614C6.20499 34.7282 5.06738 33.25 5.06738 31.517V25.8847C5.06738 24.0498 6.35337 22.4952 8.03506 22.1384C8.28236 22.0874 8.52967 22.0619 8.77697 22.0619H13.9209"
        stroke="#1A85B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default BigCallcenter;
